import { getQuarter } from 'date-fns'
import React from 'react'
import { Link } from 'react-router-dom'

import { RedGreenText } from '../../../../components/RedGreenText'
import { dateStrToDate, shortFormatNumber } from '../../../../util'
import { ManagerFundItemData } from '../../constants'
import { getInvestorNameFromFiler } from '../../utils'
import { ListCardChart } from '../Charts'
import { CardHeader } from './CardHeader'

interface Props extends Omit<ManagerFundItemData, 'topInvestments'> {
  href: string
  highlightHeaderLabel?: string
  bottomSection: React.ReactNode
}

export function ListCard({ filer, highlightHeaderLabel, latestSummaries, href, bottomSection }: Props) {
  const [activeChartTooltipIndex, setActiveChartTooltipIndex] = React.useState<number | null>(null)
  const chartData = React.useMemo(
    () =>
      latestSummaries
        .map((item) => {
          const reportDate = dateStrToDate(item.reportDate)
          const quarter = getQuarter(reportDate)
          return {
            ...item,
            value: item.totalSumOfUsdValue,
            year: `${reportDate.getFullYear()}Q${quarter}`,
            quarter,
          }
        })
        .reverse(),
    [latestSummaries]
  )

  const lastSummary = chartData[chartData.length - 1]
  const investorName = getInvestorNameFromFiler(filer)

  return (
    <div className="h-full rounded-lg border border-primary">
      {/* Temporarly reload document because we don't have proper loaders yet */}
      <Link to={href} title={investorName} className="no-underline" reloadDocument>
        <div className="p-3 pb-0">
          <CardHeader
            headerLabel={investorName}
            subHeaderLabel={filer.seriesName ? filer.filerName : undefined}
            headerValue={lastSummary.totalSumOfUsdValue ? shortFormatNumber(lastSummary.totalSumOfUsdValue) : null}
            highlightHeaderLabel={highlightHeaderLabel}
            subHeaderValue={
              activeChartTooltipIndex !== null ? (
                <RedGreenText value={null} rightContent={null}>
                  {shortFormatNumber(chartData[activeChartTooltipIndex].value, { defaultValue: '—' })}
                </RedGreenText>
              ) : (
                <>
                  {lastSummary.turnoverPerc ? (
                    <RedGreenText value={lastSummary.turnoverPerc} rightContent={null}>
                      {shortFormatNumber(lastSummary.turnoverPerc, { defaultValue: '—' })}
                      {Number.isFinite(lastSummary.turnoverPerc) ? `%${' '}last Q` : ''}
                    </RedGreenText>
                  ) : null}
                </>
              )
            }
          />
          <div className="cursor-pointer py-2">
            <ListCardChart data={chartData} onActiveTooltipIndexChange={setActiveChartTooltipIndex} />
          </div>
        </div>
      </Link>
      <div className="px-3 pb-2">{bottomSection}</div>
    </div>
  )
}
